/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
 * Zokos (carried over from the Warehouse 1.16.9 theme): on screens up to 1000px wide, show the
 * product gallery inside the product info card, between the title/price and the option picker,
 * instead of above the card. layout/theme.liquid loads this file before theme.js, so the gallery is
 * in place before the theme initialises it. The theme's variant re-render only swaps the blocks it
 * owns, so the moved gallery stays put. If an element is missing, the default layout is kept.
 */
(function () {
  if (!document.body.classList.contains('template-product')) {
    return;
  }

  var section = document.querySelector('[data-section-type="product"]');
  var wrapper = section && section.querySelector('.product-block-list__wrapper');
  var gallery = section && section.querySelector('.product-block-list__item--gallery');
  var info = section && section.querySelector('.product-block-list__item--info');

  if (!wrapper || !gallery || !info) {
    return;
  }

  function syncGalleryPosition() {
    var isMobile = window.innerWidth < 1000;
    if (isMobile) {
      var target = info.querySelector('.product-info__block-item--variant-selector') || info.querySelector('.product-info__block-item--buy-buttons');
      if (target && gallery.parentNode !== target.parentNode) {
        target.parentNode.insertBefore(gallery, target);
        gallery.classList.add('zokos-mobile-gallery');
        Array.prototype.forEach.call(gallery.querySelectorAll('button:not([type])'), function (button) {
          button.type = 'button';
        });
      }
    } else if (gallery.parentNode !== wrapper) {
      wrapper.insertBefore(gallery, info);
      gallery.classList.remove('zokos-mobile-gallery');
    }
  }

  syncGalleryPosition();
  window.addEventListener('resize', syncGalleryPosition);
})();


/*
 * Zokos: live product counts on the homepage (sections/zokos-hero.liquid and zokos-departments.liquid).
 * Liquid caps product counts at 25,001, so those sections mark larger counts with data-zk-count-url
 * (the collection's storefront JSON) and this fills in the real number, rounded down the same way as
 * snippets/zokos-count.liquid (35,477 -> "35,000+"). The section's own text stays if the request fails.
 */
(function () {
  var counts = document.querySelectorAll('[data-zk-count-url]');

  Array.prototype.forEach.call(counts, function (element) {
    fetch(element.getAttribute('data-zk-count-url'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var count = data && data.collection && data.collection.products_count;

        if (!count) {
          return;
        }

        var shown = count >= 10000 ? Math.floor(count / 1000) * 1000 : count >= 1000 ? Math.floor(count / 100) * 100 : count;
        element.textContent = shown.toLocaleString('en-US') + (count > shown ? '+' : '');
      })
      .catch(function () {});
  });
})();


/*
 * Zokos: load the product grid of tag-filtered collections (/collections/hardware/condition_used).
 * Shopify's product query on those is slow until it is cached and can stall the whole page into a 500,
 * so sections/main-collection.liquid leaves the cards out of the full page and shows a "Loading
 * products…" note (data-zokos-products-retry); the note also replaces a grid whose query failed.
 * This fetches the collection section (Section Rendering API, the same request the theme makes when
 * sorting or paging), retrying while the query is still cold, and swaps in the first result that has
 * products. It also runs after the theme's own reloads. If every try fails, a "Try again" button shows.
 */
(function () {
  var section = document.querySelector('[data-section-type="collection"]');

  if (!section) {
    return;
  }

  // The first fetch runs at once; the retries give Shopify time to finish caching the query
  var delays = [0, 1000, 2000, 4000, 8000, 12000];
  var attempt = 0;
  var generation = 0;
  var busy = false;
  var timer = null;

  function placeholder() {
    return section.querySelector('.collection__dynamic-part [data-zokos-products-retry]');
  }

  function showFailure(element) {
    element.querySelector('[data-zokos-retry-loading]').hidden = true;
    element.querySelector('[data-zokos-retry-failed]').hidden = false;
  }

  function scheduleRetry() {
    var element = placeholder();

    if (busy) {
      return;
    }

    if (!element) {
      attempt = 0;
      return;
    }

    if (attempt >= delays.length) {
      showFailure(element);
      return;
    }

    busy = true;
    timer = setTimeout(reloadProducts, delays[attempt++], generation);
  }

  function reloadProducts(startedIn) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', section.getAttribute('data-section-id'));
    // A fresh URL per try, so a cached copy of the failed render is never served again
    url.searchParams.set('zokos_retry', Date.now());

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        // The theme started its own reload (sort, page) in the meantime: its result wins
        if (startedIn !== generation) {
          return;
        }

        busy = false;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var fresh = temp.querySelector('.collection__dynamic-part');
        var current = section.querySelector('.collection__dynamic-part');

        if (fresh && current && !fresh.querySelector('[data-zokos-products-retry]')) {
          current.innerHTML = fresh.innerHTML;
          attempt = 0;
          return;
        }

        scheduleRetry();
      })
      .catch(function () {
        if (startedIn === generation) {
          busy = false;
          scheduleRetry();
        }
      });
  }

  section.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zokos-retry-button]');

    if (!button) {
      return;
    }

    var element = placeholder();

    if (!element || busy) {
      return;
    }

    element.querySelector('[data-zokos-retry-failed]').hidden = true;
    element.querySelector('[data-zokos-retry-loading]').hidden = false;
    attempt = 0;
    busy = true;
    reloadProducts(generation);
  });

  document.addEventListener('theme:loading:start', function () {
    clearTimeout(timer);
    generation++;
    attempt = 0;
    busy = false;
  });

  document.addEventListener('theme:loading:end', scheduleRetry);

  scheduleRetry();
})();


/*
 * Zokos: condition grades block on product pages (snippets/zokos-condition.liquid). Every grade of the listing is
 * server-rendered with its definition; when the shopper picks another variant, move the "selected" mark to the
 * grade of the new variant's Condition option. The theme dispatches variant:changed on the product form, which
 * contains the block (the quick view has its own form and block).
 */
document.addEventListener('variant:changed', function (event) {
  var form = event.target;
  var variant = event.detail && event.detail.variant;

  if (!form || !form.querySelectorAll || !variant || !variant.options) {
    return;
  }

  Array.prototype.forEach.call(form.querySelectorAll('[data-zokos-condition]'), function (block) {
    var value = variant.options[parseInt(block.getAttribute('data-option-index'), 10)];

    Array.prototype.forEach.call(block.querySelectorAll('[data-zokos-grade-value]'), function (item) {
      var selected = item.getAttribute('data-zokos-grade-value') === value;

      item.classList.toggle('is-selected', selected);

      if (selected) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  });
});


/*
 * Zokos: rScan product identifier line in the product info card (snippets/product-info.liquid). It shows the variant
 * barcode, which rScan sets to the same value on every variant of a listing; if a variant ever carries another one,
 * show the selected variant's. variant:changed is dispatched on the product form, which contains the line.
 * 2026-10-17: a line read from the product metafield rscan.identifier (data-zokos-rscan-fixed) is the same for every
 * variant and is left alone; the barcode may become a plain GTIN.
 */
document.addEventListener('variant:changed', function (event) {
  var form = event.target;
  var variant = event.detail && event.detail.variant;
  var barcode = variant && typeof variant.barcode === 'string' ? variant.barcode.trim() : '';

  if (!form || !form.querySelectorAll || !barcode) {
    return;
  }

  Array.prototype.forEach.call(form.querySelectorAll('[data-zokos-rscan-id]:not([data-zokos-rscan-fixed])'), function (value) {
    value.textContent = barcode;
  });
});


/*
 * Zokos: in-stock alternatives for the "nothing here" moments: sold-out product pages (snippets/zokos-sold-out.liquid,
 * compact rows) and the help page of searches with no in-stock match and 404s (snippets/zokos-help-page.liquid, the
 * store's product grid). Each [data-zokos-similar] block keeps what the server already rendered (a sold-out page's
 * rscan.similar_products) and, when that is fewer than two, tries these sources in order until it has data-limit
 * cards, all rendered by data-zokos-similar-section (zokos-similar-products or zokos-similar-grid; both keep only items
 * in stock):
 *   1. Shopify's related-product recommendations for the page's product (data-product-id);
 *   2. on a search, the sold-out listing the words match (search/suggest with unavailable products last), whose
 *      related recommendations are the closest alternatives ("emtek 4212meus19lh" -> other Melrose handlesets);
 *   3. a store search on data-query, then on the words without model numbers, then on the first word (the brand).
 * Cards are de-duplicated by URL and placeholder cards (.zk-skeleton) are replaced. With nothing to show, the whole
 * block (heading included) is removed; the links around it remain.
 */
(function () {
  var blocks = document.querySelectorAll('[data-zokos-similar]');

  if (!blocks.length || !window.fetch) {
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var results = temp.querySelector('[data-zokos-similar-results]');
        return results ? Array.prototype.slice.call(results.querySelectorAll(':scope > .product-item')) : [];
      })
      .catch(function () {
        return [];
      });
  }

  function recommendationsUrl(productId, section) {
    return root + 'recommendations/products?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related&section_id=' + section;
  }

  function searchUrl(query, section) {
    return root + 'search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&section_id=' + section;
  }

  // The id of a sold-out listing these words name, if any (they are sorted last, after anything in stock)
  function soldOutMatch(query) {
    return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (body) {
        var products = (body && body.resources && body.resources.results && body.resources.results.products) || [];

        for (var i = 0; i < products.length; i++) {
          if (products[i] && products[i].available === false && products[i].id) {
            return products[i].id;
          }
        }

        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function cardKey(card) {
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : '';
  }

  // An old product URL or a title becomes search words: "kohler-k-24546-bl-...-matte-black-1" -> "kohler k 24546 bl ... matte black"
  function queryFromText(text) {
    var words = String(text || '').replace(/[-_/]+/g, ' ').replace(/\s+/g, ' ').trim().split(' ');

    // Shopify adds -1, -2 ... to a repeated handle
    if (words.length > 1 && /^\d{1,2}$/.test(words[words.length - 1])) {
      words.pop();
    }

    return words.join(' ').slice(0, 200);
  }

  // The full words, then without model numbers (any word with a digit), then the first word, which is the brand
  function searchQueries(query) {
    var words = query.split(' ');
    var candidates = [
      query,
      words.filter(function (word) { return !/\d/.test(word); }).join(' '),
      /\d/.test(words[0]) ? '' : words[0]
    ];

    return candidates.filter(function (candidate, index) {
      return candidate && candidates.indexOf(candidate) === index;
    });
  }

  Array.prototype.forEach.call(blocks, function (block) {
    var limit = parseInt(block.getAttribute('data-limit'), 10) || 4;
    var serverCount = parseInt(block.getAttribute('data-server-count'), 10) || 0;
    var productId = block.getAttribute('data-product-id');
    var query = queryFromText(block.getAttribute('data-query'));
    var section = block.getAttribute('data-zokos-similar-section') || 'zokos-similar-products';
    var list = block.querySelector('[data-zokos-similar-list]');

    if (!list || block.hidden) {
      return;
    }

    // Enough was server-rendered (and is in the HTML agents read): nothing to fetch.
    if (serverCount >= 2) {
      return;
    }

    var sources = [];

    if (productId) {
      sources.push(function () { return fetchCards(recommendationsUrl(productId, section)); });
    } else if (query) {
      sources.push(function () {
        return soldOutMatch(query).then(function (id) {
          return id ? fetchCards(recommendationsUrl(id, section)) : [];
        });
      });
    }

    if (query) {
      searchQueries(query).forEach(function (words) {
        sources.push(function () { return fetchCards(searchUrl(words, section)); });
      });
    }

    var seen = {};
    var shown = 0;

    Array.prototype.forEach.call(list.querySelectorAll('.product-item:not(.zk-skeleton)'), function (card) {
      seen[cardKey(card)] = true;
      shown++;
    });

    function add(cards) {
      cards.forEach(function (card) {
        var key = cardKey(card);

        if (shown >= limit || !key || seen[key]) {
          return;
        }

        Array.prototype.forEach.call(list.querySelectorAll('.zk-skeleton'), function (placeholder) {
          placeholder.parentNode.removeChild(placeholder);
        });

        seen[key] = true;
        list.appendChild(card);
        shown++;
      });
    }

    function next(index) {
      if (index >= sources.length || shown >= limit) {
        return Promise.resolve();
      }

      return sources[index]().then(function (cards) {
        add(cards);
        return next(index + 1);
      });
    }

    next(0).then(function () {
      Array.prototype.forEach.call(list.querySelectorAll('.zk-skeleton'), function (placeholder) {
        placeholder.parentNode.removeChild(placeholder);
      });

      if (shown === 0) {
        var emptyCard = block.closest && block.closest('[data-zokos-similar-card]');
        if (emptyCard && emptyCard.parentNode) {
          emptyCard.parentNode.removeChild(emptyCard);
        } else if (block.parentNode) {
          block.parentNode.removeChild(block);
        }
        return;
      }

      block.classList.add('is-loaded');
      var similarCard = block.closest && block.closest('[data-zokos-similar-card]');
      if (similarCard) {
        similarCard.hidden = false;
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-zk-similar-jump]'), function (btn) {
        btn.hidden = false;
      });
    });
  });
})();


/*
 * Zokos: make the "Click on image to zoom" / "Roll over image to zoom in" caption (.product-gallery__zoom-notice)
 * clickable so shoppers who tap the caption itself open the gallery zoom instead of hitting a dead click.
 */
document.addEventListener('click', function (event) {
  var notice = event.target && event.target.closest && event.target.closest('.product-gallery__zoom-notice');
  if (!notice) {
    return;
  }
  var gallery = notice.closest('.product-gallery');
  if (!gallery) {
    return;
  }
  var img = gallery.querySelector('.product-gallery__carousel-item.is-selected .product-gallery__image') ||
            gallery.querySelector('.product-gallery__image');
  if (img) {
    img.click();
  }
});


/*
 * Zokos (2026-10-22): keep Make an Offer after a variant switch. The Make An Offer app adds its button
 * (#mf_container > button.mf_button) to the product form's <buy-button> once, on load, and Warehouse replaces the buy
 * buttons on every variant switch, so the button was gone until a reload. Put the app's own element (its click
 * listener attached) back after Add to cart once the theme has re-rendered. Not on a sold-out variant (no
 * <buy-button>); it comes back with the next available one.
 * The app builds its offer form from the variant it read last, and it reads again only on a change event from the
 * inputs it found in the form on load (500 ms later). Warehouse replaces the option inputs on every switch too, so from
 * the second switch on, the offer form kept the first switch's variant. After each switch, send it that change event
 * from the form's form_type input, which the theme never replaces; the event does not bubble, so the theme's delegated
 * listeners never see it.
 */
(function () {
  var saved = null;
  var savedAddMargin = '';

  document.addEventListener('variant:changed', function (event) {
    var form = event.target;

    if (!form || !form.classList || !form.classList.contains('mf_product_form')) {
      return;
    }

    var current = form.querySelector('#mf_container');

    if (current) {
      var add = current.parentNode && current.parentNode.querySelector('.product-form__add-button:not(.mf_button)');
      saved = current;
      savedAddMargin = add ? add.style.marginBottom : '';
    }

    setTimeout(function () {
      var formType = form.querySelector('input[name="form_type"]');

      if (formType) {
        formType.dispatchEvent(new Event('change', { bubbles: false }));
      }

      var buyButton = form.querySelector('.product-form__payment-container buy-button');

      if (!saved || form.querySelector('#mf_container') || !buyButton) {
        return;
      }

      var add = buyButton.querySelector('.product-form__add-button');

      if (add && savedAddMargin) {
        add.style.marginBottom = savedAddMargin;
      }

      buyButton.appendChild(saved);
    }, 0);
  });
})();


/*
 * Zokos (2026-10-25): on phones the cart drawer covers the whole product page, and the browser's Back (an iPhone or
 * Android back swipe) took ad visitors who had just added an item off the site, back to Google, instead of closing it.
 * While the drawer is open on a phone product page it owns one history entry, so Back closes the drawer and the shopper
 * stays on the page with the item in the cart. Closing it any other way (the header's X, a tap outside, Escape) gives
 * that entry back, so the next Back works as before. Checkout and links in the drawer leave the page and keep the
 * entry: Back from checkout returns to this product page, and one more Back leaves it. The drawer is marked
 * data-zk-closed-by="back" for the ad tracker. Product pages only (template-product, the ChatGPT ad view included):
 * collection and search pages reload their grid on popstate (theme.js), and Back there stays on the site anyway. Up to
 * 640px, Warehouse's phone breakpoint, where the drawer fills the screen.
 */
(function () {
  var drawer = document.getElementById('mini-cart');

  if (!drawer || !document.body.classList.contains('template-product') || !window.history || !history.pushState || !window.MutationObserver || !window.matchMedia) {
    return;
  }

  var phone = window.matchMedia('(max-width: 640px)');
  var pushed = false;
  var leaving = false;

  function isOpen() {
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function ownsEntry() {
    return Boolean(history.state && history.state.zkMiniCart);
  }

  new MutationObserver(function () {
    if (isOpen()) {
      if (!pushed && phone.matches) {
        history.pushState({ zkMiniCart: true }, '');
        pushed = true;
      }
      return;
    }

    if (pushed) {
      pushed = false;

      if (!leaving && ownsEntry()) {
        history.back();
      }
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });

  window.addEventListener('popstate', function () {
    if (!pushed || !isOpen()) {
      return;
    }

    pushed = false;
    drawer.setAttribute('data-zk-closed-by', 'back');

    // The header's cart toggle closes the drawer through the theme (aria state, focus trap, scroll lock)
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');

    if (toggle) {
      toggle.click();
    }
  });

  // The drawer is the cart form: Checkout submits it. Its links leave the page, except the quantity and Remove links
  // (data-action), which the theme handles in place.
  drawer.addEventListener('submit', function () {
    leaving = true;
  });

  drawer.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('a[href]:not([data-action])')) {
      leaving = true;
    }
  });

  // Back from checkout can restore this page from the back-forward cache, drawer open, on its own entry
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      leaving = false;
      pushed = isOpen() && ownsEntry();
    }
  });
})();


/*
 * Zokos (2026-10-28): 1-tap Model/MPN copy button in snippets/product-meta.liquid ([data-zk-copy-mpn]) and
 * backdrop-tap close for the PhotoSwipe image zoom modal (.pswp) so mobile shoppers who tap outside the zoomed
 * photo dismiss the overlay cleanly instead of getting stuck with rage/dead taps.
 */
document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || typeof target.closest !== 'function') {
    return;
  }

  var copyBtn = target.closest('[data-zk-copy-mpn]');
  if (copyBtn) {
    var mpn = copyBtn.getAttribute('data-zk-copy-mpn') || '';
    if (!mpn) {
      return;
    }
    var markCopied = function () {
      copyBtn.textContent = 'Copied \u2713';
      copyBtn.classList.add('is-copied');
      clearTimeout(copyBtn._zkCopyTimer);
      copyBtn._zkCopyTimer = setTimeout(function () {
        copyBtn.textContent = 'Copy';
        copyBtn.classList.remove('is-copied');
      }, 2000);
    };
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(mpn).then(markCopied).catch(markCopied);
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = mpn;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}
      markCopied();
    }
    return;
  }

  var pswp = target.closest('.pswp.pswp--open');
  if (pswp && !target.closest('.pswp__img, .pswp__button, .pswp__top-bar, .pswp__caption')) {
    var closeBtn = pswp.querySelector('.pswp__button--close');
    if (closeBtn) {
      closeBtn.click();
    }
  }

  var scrollBtn = target.closest('[data-zk-scroll-to]');
  if (scrollBtn) {
    var sel = scrollBtn.getAttribute('data-zk-scroll-to');
    var dest = sel ? document.querySelector(sel) : null;
    if (dest) {
      var collapsible = dest.closest('.card__collapsible');
      if (collapsible && collapsible.id) {
        var toggleBtn = document.querySelector('[aria-controls="' + collapsible.id + '"][aria-expanded="false"]');
        if (toggleBtn) {
          toggleBtn.click();
        }
      }
      var expandable = dest.closest('.expandable-content[aria-expanded="false"]');
      if (expandable) {
        var expandBtn = expandable.querySelector('.expandable-content__toggle');
        if (expandBtn) {
          expandBtn.click();
        }
      }
      dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return;
  }

  var searchWrapper = target.closest('.search-bar__input-wrapper');
  if (searchWrapper && !target.closest('input, button, a')) {
    var searchInput = searchWrapper.querySelector('.search-bar__input');
    if (searchInput) {
      searchInput.focus();
    }
  }
});


/*
 * Zokos (2026-10-29): phone buy bar (snippets/zokos-buybar.liquid). Shown on phones while the product page's own buy
 * buttons are out of view; its Add to cart and Make an Offer buttons trigger the page's real buttons, and its price,
 * compare-at price, condition grade (Open Box, Sealed, Used - Very Good — never "Used (Open Box)"), and availability
 * follow variant:changed.
 */
(function () {
  var bar = document.querySelector('[data-zk-buybar]');

  if (!bar) {
    return;
  }

  var form = document.getElementById(bar.getAttribute('data-form-id')) || bar.closest('form');
  var optionIndex = parseInt(bar.getAttribute('data-option-index'), 10);
  var priceEl = bar.querySelector('[data-zk-buybar-price]');
  var compareEl = bar.querySelector('[data-zk-buybar-compare]');
  var conditionEl = bar.querySelector('[data-zk-buybar-condition]');
  var atcBtn = bar.querySelector('[data-zk-buybar-atc]');
  var offerBtn = bar.querySelector('[data-zk-buybar-offer]');
  var infoBtn = bar.querySelector('[data-zk-buybar-info]');
  var conditionsEl = bar.querySelector('[data-zk-buybar-conditions]');
  var conditions = {};
  var buttonsInView = true;

  if (conditionsEl) {
    try {
      conditions = JSON.parse(conditionsEl.textContent) || {};
    } catch (e) {}
  }

  function buyButtonsBlock() {
    return (form && form.querySelector('.product-form__buy-buttons')) || document.querySelector('.product-form__buy-buttons');
  }

  function realAtc() {
    return form && form.querySelector('.product-form__payment-container .product-form__add-button:not(.mf_button)');
  }

  function realOffer() {
    return (form && form.querySelector('#mf_container button.mf_button, button.mf_button')) || document.querySelector('#mf_container button.mf_button, #make-an-offer-btn');
  }

  function syncOffer() {
    if (!offerBtn) {
      return;
    }

    var offer = realOffer();
    var atc = realAtc();
    offerBtn.hidden = !offer || Boolean(atc && atc.disabled);
  }

  function syncVisible() {
    var show = !buttonsInView && window.innerWidth <= 767;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('zk-buybar-on', show);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') {
      return '';
    }

    var format = (window.theme && (window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat)) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  }

  var observer = null;

  function observeBuyButtons() {
    var target = buyButtonsBlock();

    if (!target || !('IntersectionObserver' in window)) {
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          buttonsInView = entry.isIntersecting;
          syncVisible();
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(target);
  }

  observeBuyButtons();
  syncOffer();
  window.addEventListener('resize', syncVisible);

  // The Make an Offer app injects its button after load; watch briefly so the bar's offer button appears with it
  var offerChecks = 0;
  var offerTimer = setInterval(function () {
    syncOffer();

    if (!offerBtn.hidden || ++offerChecks >= 20) {
      clearInterval(offerTimer);
    }
  }, 400);

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var atc = realAtc();

      if (atc && !atc.disabled) {
        atc.click();
      }
    });
  }

  if (offerBtn) {
    offerBtn.addEventListener('click', function () {
      var offer = realOffer();

      if (offer) {
        offer.click();
      }
    });
  }

  if (infoBtn) {
    infoBtn.addEventListener('click', function () {
      var target = (form && form.querySelector('.product-form__variants, .product-form__info-list')) || buyButtonsBlock();

      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) {
      return;
    }

    if (priceEl) {
      var pagePrice = form && form.querySelector('.zokos-price > .price:not(.price--compare)');
      priceEl.textContent = (pagePrice && pagePrice.textContent.trim()) || formatMoney(variant.price);
    }

    if (compareEl) {
      if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
        var pageCompare = form && form.querySelector('.zokos-price .price--compare');
        compareEl.textContent = (pageCompare && pageCompare.textContent.trim()) || formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (conditionEl && optionIndex >= 0 && variant.options) {
      var raw = variant.options[optionIndex] || '';
      conditionEl.textContent = conditions[raw] || raw;
    }

    if (atcBtn) {
      var atc = realAtc();
      atcBtn.disabled = !variant.available;

      if (atc) {
        atcBtn.textContent = atc.textContent.trim();
      }
    }

    setTimeout(function () {
      observeBuyButtons();
      syncOffer();
    }, 50);
  });
})();


